import React from "react";
import { getBackgroundColor, getInitials, getTypeTextColor } from "./helper";

const UserInfoTile = ({ user, handleRemoveUser, handleSelectUser, selectedUsers, is_add = false, is_selected = false }) => {
  return (
    <div
      className={`w-full h-10 rounded-full my-2 px-1 cursor-pointer ${getBackgroundColor(
        user?.type
      )}`}
    >
      <div className="w-full h-full flex items-center justify-between">
        <div onClick={(e) => {
          e.preventDefault();
          if(!is_add) handleSelectUser(user);
        }} className="w-[80%] h-full flex items-center">
          <div>
            <div className="bg-[#D9D9D9] w-8 h-8 rounded-full flex justify-center items-center font-medium tracking-wide">
              {getInitials(user?.name)}
            </div>
          </div>
          <div className="ml-3 w-full ">
            <p className="text-[13px] font-medium font-inter truncate">
              {user?.name}
            </p>
            <p
              className={`w-[90%] text-[12px] font-inter truncate ${getTypeTextColor(
                user?.type
              )}`}
            >
              {user?.dept_name ? user.dept_name.join(", ") : user?.type}
            </p>
          </div>
        </div>
        {is_add && (
          <span
            onClick={(e) => {
              e.preventDefault();
              handleRemoveUser(user);
            }}
            className="fa-sharp fa-regular fa-xmark mr-3"
          ></span>
        )}
        {is_selected && selectedUsers?.find(e => e.id === user?.id) && (
          <span
            className="fa-regular fa-check text-[#3cc274] mr-3"
          ></span>
        )}
      </div>
    </div>
  );
};

export default UserInfoTile;
